export default __webpack_public_path__ + "static/media/career.deef8a4a.md";